module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-grid-feature-02-95812f056fda10cd4eaffd971c2093d6.jpg";